import { registriereErpArt } from '../registry'
import { RegieEinstellungen } from './RegieEinstellungen'
import { RegieErpDetail } from './RegieErpDetail'
import { RegieErpVorzeige } from './RegieErpVorzeige'

/** AP-27-D — der Regiebericht meldet sich im ERP an: Vorzeige, Detailteil, Einstellungen. */
registriereErpArt({ kind: 'REGIE', Vorzeige: RegieErpVorzeige, Detail: RegieErpDetail, Einstellungen: RegieEinstellungen })
